import { all, call, takeLatest } from 'redux-saga/effects';

import * as constants from './company-context.constants';
import * as types from './company-context.types';
import * as services from './company-context.saga-services';

function* invokeInitialCompanyContextPage() {
  yield call(services.initialCompanyContextPage);
}

function* invokeCreateCompanyContext(action: types.ICreateCompanyContext) {
  yield call(services.createCompanyContext, action);
}

function* invokeUpdateCompanyContext(action: types.IUpdateCompanyContext) {
  yield call(services.updateCompanyContext, action);
}

function* invokeDeleteCompanyContext(action: types.IDeleteCompanyContext) {
  yield call(services.deleteCompanyContext, action);
}

export function* watchCompanyContextPageSaga() {
  yield all([
    takeLatest(constants.COMPANY_CONTEXT_PAGE, invokeInitialCompanyContextPage),
    takeLatest(constants.CREATE_COMPANY_CONTEXT, invokeCreateCompanyContext),
    takeLatest(constants.UPDATE_COMPANY_CONTEXT, invokeUpdateCompanyContext),
    takeLatest(constants.DELETE_COMPANY_CONTEXT, invokeDeleteCompanyContext),
  ]);
}
